/* Pulsión orgánica — comportamiento mínimo.
   Todo lo visual es CSS; aquí solo van la aparición al desplazarse,
   la cabecera pegada, el cajón móvil y los filtros de colección.
   Respeta prefers-reduced-motion en todo momento. */
(function () {
  'use strict';
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- aparición al entrar en pantalla ---- */
  function aparecer() {
    var piezas = document.querySelectorAll('.pn-aparece');
    if (!piezas.length) return;
    if (quieto || !('IntersectionObserver' in window)) {
      piezas.forEach(function (p) { p.classList.add('pn-visible'); });
      return;
    }
    var ojo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pn-visible'); ojo.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    piezas.forEach(function (p) { ojo.observe(p); });
  }

  /* ---- cabecera: se compacta al desplazarse ---- */
  function cabecera() {
    var cab = document.querySelector('.pn-cab');
    if (!cab) return;
    var ultimo = -1;
    function mirar() {
      var pegada = window.scrollY > 12;
      if (pegada !== ultimo) { cab.classList.toggle('pn-cab--pegada', pegada); ultimo = pegada; }
    }
    mirar();
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(mirar);
    }, { passive: true });
  }

  /* ---- cajón de navegación en móvil ---- */
  function cajon() {
    var boton = document.querySelector('.pn-cab__hamburguesa');
    var caja = document.getElementById('pn-cajon-caja');
    var panel = document.getElementById('pn-cajon');
    var velo = document.getElementById('pn-cajon-velo');
    if (!boton || !caja || !panel || !velo) return;
    function abrir(si) {
      caja.dataset.abierto = si ? 'true' : 'false';
      boton.setAttribute('aria-expanded', si ? 'true' : 'false');
      document.documentElement.style.overflow = si ? 'hidden' : '';
      if (si) { var f = panel.querySelector('a,button'); if (f) f.focus(); }
    }
    boton.addEventListener('click', function () {
      abrir(caja.dataset.abierto !== 'true');
    });
    velo.addEventListener('click', function () { abrir(false); });
    var cerrar = panel.querySelector('.pn-cajon__cerrar');
    if (cerrar) cerrar.addEventListener('click', function () { abrir(false); boton.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && caja.dataset.abierto === 'true') { abrir(false); boton.focus(); }
    });
  }

  /* ---- onda al pulsar un botón: nace donde tocas ---- */
  function ondaBotones() {
    if (quieto) return;
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest ? e.target.closest('.pn-btn') : null;
      if (!b) return;
      var r = b.getBoundingClientRect();
      b.style.setProperty('--pn-x', (e.clientX - r.left) + 'px');
      b.style.setProperty('--pn-y', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---- filtros por subcategoría en la colección ---- */
  function filtros() {
    var barra = document.getElementById('pn-filtros');
    var buscador = document.getElementById('pn-busqueda-productos');
    if (!barra && !buscador) return;
    var botones = barra ? barra.querySelectorAll('.pn-filtro') : [];
    var fichas = document.querySelectorAll('[data-sub]');
    var cuenta = document.getElementById('pn-filtros-cuenta');
    var limpiar = document.getElementById('pn-busqueda-limpiar');
    var vacia = document.getElementById('pn-busqueda-vacia');
    var rejilla = document.querySelector('.pn-rejilla');
    var subcategoria = '*';
    var consulta = '';
    function normalizar(texto) {
      return (texto || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }
    function aplicar() {
      var visibles = 0;
      fichas.forEach(function (f) {
        var pasaSub = subcategoria === '*' || f.dataset.sub === subcategoria;
        var palabras = consulta ? consulta.split(/\s+/).filter(Boolean) : [];
        var texto = normalizar(f.dataset.search);
        var pasaTexto = palabras.every(function (palabra) { return texto.indexOf(palabra) !== -1; });
        var pasa = pasaSub && pasaTexto;
        f.hidden = !pasa;
        if (pasa) visibles++;
      });
      if (cuenta) {
        cuenta.textContent = visibles + (visibles === 1 ? ' producto' : ' productos');
      }
      botones.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.valor === subcategoria));
      });
      if (limpiar) limpiar.hidden = !consulta;
      if (vacia) vacia.hidden = visibles !== 0;
      if (rejilla) rejilla.hidden = visibles === 0;
    }
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        subcategoria = b.dataset.valor;
        aplicar();
      });
    });
    if (buscador) {
      buscador.addEventListener('input', function () {
        consulta = normalizar(buscador.value);
        aplicar();
      });
    }
    if (limpiar) {
      limpiar.addEventListener('click', function () {
        buscador.value = '';
        consulta = '';
        aplicar();
        buscador.focus();
      });
    }
    aplicar();
  }



  /* PN-SUBSANACION-LSSI-2026 */
  function enlazarPoliticaCookies() {
    var ingles = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var ruta = (ingles ? '/en' : '') + '/pages/politica-de-cookies';
    function aplicar() {
      var enlace = document.getElementById('shopify-pc__banner__body-policy-link');
      if (!enlace) return false;
      enlace.href = ruta;
      enlace.textContent = ingles ? 'Cookie policy' : 'Política de cookies';
      return true;
    }
    if (aplicar()) return;
    var observador = new MutationObserver(function () {
      if (aplicar()) observador.disconnect();
    });
    observador.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observador.disconnect(); }, 15000);
  }

  function arrancar() { aparecer(); cabecera(); cajon(); ondaBotones(); filtros(); enlazarPoliticaCookies(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else { arrancar(); }
})();
